var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsideFavouriteIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6432 27.0521L17.4974 27.1979L17.337 27.0521C10.4099 20.7667 5.83073 16.6104 5.83073 12.3958C5.83073 9.47917 8.01823 7.29167 10.9349 7.29167C13.1807 7.29167 15.3682 8.75 16.1411 10.7333H18.8536C19.6266 8.75 21.8141 7.29167 24.0599 7.29167C26.9766 7.29167 29.1641 9.47917 29.1641 12.3958C29.1641 16.6104 24.5849 20.7667 17.6432 27.0521ZM24.0599 4.375C21.5224 4.375 19.087 5.55625 17.4974 7.40833C15.9078 5.55625 13.4724 4.375 10.9349 4.375C6.44323 4.375 2.91406 7.88958 2.91406 12.3958C2.91406 17.8938 7.8724 22.4 15.3828 29.2104L17.4974 31.1354L19.612 29.2104C27.1224 22.4 32.0807 17.8938 32.0807 12.3958C32.0807 7.88958 28.5516 4.375 24.0599 4.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsideFavouriteIconWhite);
export default __webpack_public_path__ + "static/media/aside-favourite-icon-white.ce2eb1c5bdca18da3af14e67f5de9e2c.svg";
export { ForwardRef as ReactComponent };